import { isAxiosError } from "axios";

export const pdfExportMessageKeys = {
  generation: "pdfExportErrors.generation",
  timeout: "pdfExportErrors.timeout",
  requestTimeout: "pdfExportErrors.requestTimeout",
  status: "pdfExportErrors.status",
  download: "pdfExportErrors.download",
  notReady: "pdfExportErrors.notReady",
  failed: "pdfExportErrors.failed",
  unknown: "pdfExportErrors.unknown",
} as const;

export type PdfExportMessageCategory = keyof typeof pdfExportMessageKeys;

export const isPdfExportTimeout = (error: unknown): boolean => {
  if (isAxiosError(error)) {
    if (error.response?.status === 408 || error.response?.status === 504) return true;
    if (error.code === "ECONNABORTED" || error.code === "ETIMEDOUT") return true;
  }

  const message =
    typeof error === "string" ? error : error instanceof Error ? error.message : undefined;
  return message !== undefined && /\b(?:timeout|timed out|TimeoutError)\b/i.test(message);
};

export const pdfGenerationFailureCategory = (error: unknown): PdfExportMessageCategory =>
  isPdfExportTimeout(error) ? "timeout" : "generation";

export const pdfExportRequestFailureCategory = (error: unknown): PdfExportMessageCategory =>
  isPdfExportTimeout(error) ? "requestTimeout" : "unknown";

export const pdfExportRequestDiagnostic = (error: unknown) =>
  isAxiosError(error)
    ? {
        kind: "http",
        code:
          typeof error.code === "string" && /^[A-Z][A-Z_0-9]{0,31}$/.test(error.code)
            ? error.code
            : undefined,
        status: error.response?.status,
      }
    : { kind: error instanceof Error ? "error" : typeof error };
